import { useEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import PublicRoute from "../protectedRoute/publicRoute";
import PrivateRoute from "../protectedRoute/PrivateRoute";
import NotFound from "../common/notFound";
import Cookies from "js-cookie";
import ExamRoutes from "./examRoutes";
import RouteVerification from "../common/routeVerification";
import { EncodeDecode } from "../common/encodeDecode";
import setAuthToken from "../utils/setAuthToken";
import { setRptAuthToken } from "../utils/rptAxios";
import { store } from "../Redux/store";
import examActions from "../Redux/exam/actions";
import ProjectNotFound from "../common/projectNotFound";
import Login from "../pages/login";
import LandingPage from "../pages/landingPage";
import LiveTest from "../pages/liveTest";
import ThankYou from "../common/thankYou";
import Summary from "../pages/summary";
import Practice from "../common/practice";
import EndExam from "../common/endExam";
import SystemCompatibility from "../components/SystemCompatibility.tsx";
import ExamFlowPage from "../components/ExamFlowPage.tsx";
import ExamSchedules from "../pages/examSchedules.js";
import { setResInterceptor } from "../api/examApi.js";
import SecondaryCameraPage from "../components/SecondaryCameraPage.tsx";
import SystemCompatibilityPage from "../pages/systemCompatibilityPages.js";


const AppRoutes = () => {
  const navigate = useNavigate();
  const apiUrl = sessionStorage.getItem("apiUrl");
  const isVenue = sessionStorage.getItem("venue") ?? false;

  if (Cookies.get("test_engine_token")) {
    setAuthToken(Cookies.get("test_engine_token"));
    setResInterceptor();
  }

  if (sessionStorage.getItem("rps_token")) {
    setRptAuthToken(sessionStorage.getItem("rps_token"));
  }

  useEffect(() => {
    const interval = setInterval(() => {
      store.dispatch({ type: examActions.GET_HEART_BEAT });
    }, 10000);

    return () => clearInterval(interval);
  }, [store.dispatch]);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     const log = localStorage.getItem("assignedProctor");
  //     const redirected = localStorage.getItem("proctorRedirected");

  //     if (log && !redirected) {
  //       clearInterval(interval);
  //       localStorage.setItem("proctorRedirected", "true"); // ✅ prevent loop

  //       window.location.href = `/${Cookies.get("test_engine_project")}/home`;
  //       // OR
  //       // navigate(`/${Cookies.get("test_engine_project")}/home`, { replace: true });
  //     }
  //   }, 500);

  //   return () => clearInterval(interval);
  // }, [navigate]);


  const CHECK_INTERVAL = 5000;
  const INACTIVITY_LIMIT = 3 * 60 * 1000;

  useEffect(() => {
    localStorage.setItem("lastActive", Date.now().toString());
    const interval = setInterval(() => {
      const lastActive = parseInt(localStorage.getItem("lastActive") || "0", 10);
      const now = Date.now();
      if (now - lastActive > INACTIVITY_LIMIT) {
        handleSystemInactive();
      }
      localStorage.setItem("lastActive", Date.now().toString());
    }, CHECK_INTERVAL);
    return () => clearInterval(interval);
  }, []);

  // const handleSystemInactive = () => {
  //   if (isVenue) {
  //     Cookies.remove("test_engine_token");
  //     // Cookies.remove("test_engine_project");
  //     navigate(`/login?apiUrl=${apiUrl}`);
  //     sessionStorage.clear();
  //     localStorage.clear();
  //   } else {
  //     Cookies.remove("test_engine_token");
  //     // Cookies.remove("test_engine_project");
  //     sessionStorage.clear();
  //     localStorage.clear();
  //     navigate(`/${Cookies.get("test_engine_project")}/login`);
  //   }
  // };

  const handleSystemInactive = () => {
    Cookies.remove("test_engine_token");

    const project = Cookies.get("test_engine_project");

    sessionStorage.clear();
    localStorage.clear();

    if (project) {
      navigate(`/${project}/login`, { replace: true });
    } else {
      navigate("/login", { replace: true });
    }
  };




  return (
    <Routes>
      {/* <Route path="/system-compatibility" element={<SystemCompatibility />} /> */}
      <Route path="/system-compatibility" element={<SystemCompatibilityPage />} />
    
      {/* <Route path="/upload-instructions" element={<UploadInstructionsComponent />} /> */}
      {/* <Route path="/upload-instructions" element={<ExamFlowPage />} /> */}
      <Route path="/capture-identity" element={<ExamFlowPage />} />
      <Route path="/secondary-camera/:token" element={<SecondaryCameraPage />} />
      <Route
        path="/examination"
        element={
          <PublicRoute>
            <RouteVerification />
          </PublicRoute>
        }
      />
      <Route
        path="/project-not-found"
        element={
          <PublicRoute>
            <ProjectNotFound />
          </PublicRoute>
        }
      />
      <Route path="/en-de" element={<EncodeDecode />} />
      <Route path="/thank-you" element={<ThankYou />} />
      <Route path="/login" element={<Login />} />
      <Route path="/home" element={<LandingPage />} />
      <Route path="/mock-test" element={<LiveTest />} />
      <Route path="/live-test" element={<LiveTest />} />
      <Route path="/summary" element={<Summary />} />
      <Route path="/practice" element={<Practice />} />
      <Route path="/end-exam" element={<EndExam />} />
      <Route path="/exam-schedules" element={<ExamSchedules />} />
      {/* <Route
        path={
          Cookies.get("test_engine_project")
            ? `/${Cookies.get("test_engine_project")}/*`
            : undefined
        }
        element={<ExamRoutes />}
      /> */}
      <Route
        path="/:test_engine_project/*"
        element={<ExamRoutes />}
      />
      <Route
        path="*"
        element={
          <PublicRoute>
            <NotFound />
          </PublicRoute>
        }
      />
    </Routes>
  );
};

export default AppRoutes;
